import { useHistory } from 'react-router-dom';

export const ReturnToLogin = () => {
  const history = useHistory();

  history.push('/');

  return null;
};
